import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { Ticket, TicketCommentToSubmit, TicketResponse } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';
import { ZendeskFaq, ZendeskFaqResponse, ZendeskTopic } from '../entities/zendes.entity';

@Injectable({ providedIn: 'root' })
export class TicketInfrastructure {
  constructor(
    private readonly http: HttpClient,
    private readonly authStateFacade: AuthStateFacade,
  ) {}

  //TODO: remove with V5
  public getTicketsDeprecated(): Observable<Ticket[]> {
    const customerId = this.authStateFacade.customerId;
    const ticketUrl = `${environment.apihost + environment.ticketsServiceUrl}/${customerId}`;
    return this.http.get<Ticket[]>(ticketUrl);
  }

  public getTickets(page = 0, size = 10, status: 'ALL' | 'OPEN' | 'CLOSED' = 'ALL'): Observable<TicketResponse> {
    return this.http.get<TicketResponse>(
      `${environment.apihost + environment.ticketsServiceUrl}?page=${page}&size=${size}&status=${status}`,
    );
  }

  public getUnreadTickets(): Observable<number> {
    const customerId = this.authStateFacade.customerId;
    const ticketUrl = `${environment.apihost + environment.ticketsServiceUrl}/${customerId}/unread`;
    return this.http.get<number>(ticketUrl);
  }

  public postTicket(ticket: Ticket): Observable<Ticket> {
    const ticketUrl = `${environment.apihost + environment.ticketdialog}/saveticket`;
    return this.http.post<Ticket>(ticketUrl, ticket);
  }

  public postTicketComment(ticketComment: TicketCommentToSubmit): Observable<boolean> {
    const ticketUrl = `${environment.apihost + environment.ticketdialog}/savecomment`;
    return this.http.post<boolean>(ticketUrl, ticketComment);
  }

  public deleteTicketFile(fileRefForTicket: string): Observable<boolean> {
    const ticketUrl = `${environment.apihost + environment.ticketdialog}/deletefile`;
    return this.http.post<boolean>(ticketUrl, fileRefForTicket);
  }

  public postTicketStatus(ticketId: number, status: 'Closed' | 'Open'): Observable<boolean> {
    const ticketUrl = `${environment.apihost + environment.ticketdialog}/ticket/${ticketId}/status`;
    return this.http.post<boolean>(ticketUrl, status);
  }

  public postTicketFile(file: File): Observable<HttpEvent<unknown>> {
    const formData = new FormData();
    formData.append('file', file);
    const ticketUrl = `${environment.apihost + environment.ticketdialog}/uploadfile`;
    return this.http.post(ticketUrl, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public getZendeskSuggestions(term: string): Observable<ZendeskFaq[]> {
    return this.http
      .get<ZendeskFaqResponse>(`${environment.apihost}/apic/faq`, {
        params: {
          query: term,
          locale: 'de',
        },
      })
      .pipe(map((response) => response.results));
  }

  public getZendeskTopics(): Observable<ZendeskTopic[]> {
    return this.http.get<ZendeskTopic[]>(`${environment.assetshost}/assets/ticket-topics/ticket-topics.json`);
  }
}
